const RefundType = Object.freeze({
  Full: 0,
  Partial: 1,
  PartialReleaseOnly: 2,
  PartialRefundOnly: 3,
  Allowance: 4
})

export {
  RefundType
}
